<template>
    <section>
        <div class="fin-grid xl:fin-grid-cols-6 lg:fin-grid-cols-3 md:fin-grid-cols-2 fin-gap-4">
            <div v-for="(settlement, key) in paginatedSettlements"
                 :key="key"
                 class="fin-grid fin-gap-4 fin-rounded-lg fin-shadow fin-p-3"
                 :class="appearance === 'black' ? 'fin-bg-white fin-text-black' : 'fin-bg-black fin-text-white'"
            >
                <div class="fin-space-y-1">
                    <div class="fin-flex fin-justify-between fin-items-center">
                        <span class="fin-text-md fin-font-semibold fin-uppercase">{{
                                getCustomerName(settlement)
                            }}</span>

                        <el-avatar shape="circle" size="small" v-if="_.get(settlement, 'broker_avatar')"
                                   :src="_.get(settlement, 'broker_avatar')"></el-avatar>

                        <el-avatar shape="circle" size="small" v-else>{{
                                getInitials(_.get(settlement, 'broker'))
                            }}
                        </el-avatar>
                    </div>
                    <div class="fin-flex fin-justify-between fin-items-center">
                        <img class="fin-w-14" v-if="_.get(settlement, 'lender_logo')"
                             :src="_.get(settlement, 'lender_logo')"/>
                        <el-avatar shape="circle" size="small" v-else>{{
                                getInitials(_.get(settlement, 'lender_name'))
                            }}
                        </el-avatar>

                        <span>{{ _.get(settlement, 'referrer_name') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="fin-grid fin-justify-items-end fin-w-full fin-mt-3" v-if="_.size(settlements) > 42">
            <el-pagination
                background layout="total, prev, pager, next, jumper"
                :page-size="maxPerPage"
                :current-page="currentPage"
                @current-change="loadMore"
                @size-change="loadMore"
                :total="settlements.length">
            </el-pagination>
        </div>
    </section>
</template>

<script>

export default {
    name: 'SettlementsChart',
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            loading: false,
            settlements: [],
            currentPage: 1,
            maxPerPage: 42,
            showReadMore: true
        }
    },
    computed: {
        totalResults() {
            return Object.keys(this.settlements).length;
        },
        pageCount() {
            return Math.ceil(this.totalResults / this.maxPerPage);
        },
        pageOffest() {
            return this.maxPerPage * this.currentPage;
        },
        paginatedSettlements() {
            return this.settlements.slice((this.currentPage - 1) * this.maxPerPage, this.currentPage * this.maxPerPage);
        }
    },
    watch: {},
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settlements = _.get(event, 'settlements.settlements')
        })
    },
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settlements = _.get(event, 'settlements.settlements')
        })
    },
    methods: {
        getInitials(string) {
            if (string) {
                let names = string.split(' '),
                    initials = names[0].substring(0, 1).toUpperCase();

                if (names.length > 1) {
                    initials += names[names.length - 1].substring(0, 1).toUpperCase();
                }

                return initials
            }

            return ''
        },
        getCustomerName(row) {
            return _.get(row, 'applicants.0.fullName', '');
        },
        loadMore(e) {
            this.currentPage = e;
        }
    }
}
</script>
